import * as yup from 'yup'

export const schemaMigratePlan = yup.object().shape({
  periodicity: yup
    .number()
    .typeError('Preencha este campo')
    .transform(periodicity => parseInt(periodicity))
    .moreThan(0)
    .required(),
  quantity: yup
    .number()
    .typeError('Preencha este campo')
    .transform(periodicity => parseInt(periodicity))
    .moreThan(-1, 'Digite um número igual ou maior que 0')
    .required(),
  price: yup
    .number()
    .min(0, 'O valor precisa ser maior ou igual a R$ 0,00')
    .required(),
  quantityDiscount: yup.string(),
  discount: yup
    .number()
    .typeError('Preencha este campo')
    .when('quantityDiscount', {
      is: quantityDiscount => parseInt(quantityDiscount) >= 0,
      then: yup
        .number()
        .typeError('Preencha este campo')
        .moreThan(0, 'O valor precisa ser maior que R$ 0,00')
        .required(),
    }),
})

export default schemaMigratePlan
